"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineUserAttributes = defineUserAttributes;
exports.signUpCoachWithData = signUpCoachWithData;
exports.setLocalStorageItems = setLocalStorageItems;
var auth_1 = require("aws-amplify/auth");
var aws_amplify_1 = require("aws-amplify");
var aws_config_admin_1 = __importDefault(require("@fdha/aws-config-admin"));
function defineUserAttributes(coachName) {
    var given_name = coachName || 'TestUser';
    var family_name = "".concat(Date.now());
    var defaultAttributes = {
        name: "".concat(given_name, " ").concat(family_name),
        email: "".concat(given_name, "_").concat(family_name, "@faethtest.com"),
        phone_number: '+16502425609',
        'custom:domain': 'faethtest.com',
    };
    var defaultSignUpData = {
        username: "".concat(given_name, "_").concat(family_name, "@faethtest.com"),
        password: 'Faeth!123456',
        options: {
            userAttributes: defaultAttributes,
        },
    };
    return defaultSignUpData;
}
// TODO: define new type for SignUpParams
function signUpCoachWithData(signUpData) {
    return __awaiter(this, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    aws_amplify_1.Amplify.configure({
                        Auth: {
                            Cognito: {
                                userPoolClientId: aws_config_admin_1.default.cognito.adminUserPoolClientId,
                                userPoolId: aws_config_admin_1.default.cognito.adminUserPoolId,
                            },
                        },
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, (0, auth_1.signUp)(signUpData)];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error(JSON.stringify(error_1));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
function setLocalStorageItems(fetchResponse) {
    var _a;
    var tokens = fetchResponse.tokens;
    var accessToken = tokens === null || tokens === void 0 ? void 0 : tokens.accessToken;
    var accessTokenPayload = accessToken === null || accessToken === void 0 ? void 0 : accessToken.payload;
    var session = {
        idToken: (_a = tokens === null || tokens === void 0 ? void 0 : tokens.idToken) === null || _a === void 0 ? void 0 : _a.toString(),
        accessToken: accessToken === null || accessToken === void 0 ? void 0 : accessToken.toString(),
        clientId: accessTokenPayload === null || accessTokenPayload === void 0 ? void 0 : accessTokenPayload.client_id,
        accessTokenSub: accessTokenPayload === null || accessTokenPayload === void 0 ? void 0 : accessTokenPayload.sub,
    };
    var keyPrefix = "CognitoIdentityServiceProvider.".concat(session.clientId);
    var keyPrefixWithUsername = "".concat(keyPrefix, ".").concat(session.accessTokenSub);
    var ls = window.localStorage;
    if (session.idToken && session.accessToken && session.accessTokenSub) {
        ls.setItem("".concat(keyPrefixWithUsername, ".idToken"), session.idToken);
        ls.setItem("".concat(keyPrefixWithUsername, ".accessToken"), session.accessToken);
        ls.setItem("".concat(keyPrefix, ".LastAuthUser"), session.accessTokenSub);
    }
    window.localStorage.setItem('amplify-authenticator-authState', 'signedIn');
}
